import React, { useEffect, useState } from 'react'
import "./LinkedFacebook.css"
import StepsHeadingSection from '../Campaign/StepsHeadingSection/StepsHeadingSection'
import FbPageImage from "../../assets/images/image.png";
import SwitchIcon from "../../assets/images/arrow-swap-horizontal.svg";
import SponsorIcon from "../../assets/icons/sponsor.svg";
import SwitchFbModal from './SwitchFbModal/SwitchFbModal';
import { useSelector } from 'react-redux';
import UNIVERSAL from '../../config/config';

const LinkedFacebook = () => {
    const [showSwitchFbModal, setShowSwitchFbModal] = useState(false);
    const user = useSelector(state => state?.user?.user);
    const [userData,setUserData]=useState();

    function showSwitchModal(event) {
        event.preventDefault();
        setShowSwitchFbModal(true);
    }
    function notShowSwitchModal() {
        setShowSwitchFbModal(false);
    }

    useEffect(()=>{
        async function getUserProfile() {
            return fetch(UNIVERSAL.BASEURL_1 + '/biz/getBiz', {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
              },
              body: JSON.stringify({
                "businessId": user?.app_business_id
              }),
            })
              .then((response) => response.json())
              .then((responseJson) => {
                if (responseJson) {
                  console.log(responseJson.data?.profileUrl);
                  setUserData(responseJson.data);
                } else {
                  // error
                }
              })
              .catch((error) => {
                console.log(error);
              });
        }
        getUserProfile();
    },[showSwitchFbModal])

    return (
        <div id='linkedFb'>
            <StepsHeadingSection people="50,000" />
            <div className='linkedFbPage'>
                <h6 className='linkedFbPage-heading'>Your linked Facebook page</h6>
                <hr className='stepsHr' />
                <div className="linkedFbPageInfo">
                    <span className='linkedFbPage-info'>
                        <img className='linkedFbPage-img' src={userData?.profileUrl ? userData?.profileUrl : FbPageImage} alt="linked-fb-page-img" />
                        <span className='linkedFbpage-details'>
                            <p className='linkedFbPage-name'>{userData?.facebook_page_name ? userData?.facebook_page_name : "Arun excello compact homes"}</p>
                            <p className='linkedFbPage-sponsor'>Sponsored <img className='linkedFbPage-sponsor-icon' src={SponsorIcon} alt="sponsor-img" /></p>
                        </span>
                    </span>
                    <a href="" className='linkedFbPage-switch' onClick={showSwitchModal}><img src={SwitchIcon} alt="switch-icon" /> Switch</a>
                    {showSwitchFbModal && <SwitchFbModal userData={userData} closeModal={notShowSwitchModal} />}
                </div>
            </div>
        </div>
    )
}

export default LinkedFacebook